const productRouter = [
  {
    path: '/product',
    name: 'product',
    meta: {
      index: 1,
      title: '我的借款'
    },
    component: () => import('@/views/product/Index.vue')
  },
  {
    path: '/product-h5',
    name: 'productH5',
    meta: {
      index: 1,
      title: '推荐优选'
    },
    component: () => import('@/views/product/H5Index.vue')
  },
  {
    path: '/product/join',
    name: 'ProductJoin',
    meta: {
      index: 55,
      title: '产品申请'
    },
    component: () => import('@/views/product/Join.vue')
  },
  {
    path: '/product/shopping-quota',
    name: 'ProductShoppingQuota',
    meta: {
      index: 56,
      title: '购物专享额度'
    },
    component: () => import('@/views/product/ShoppingQuota.vue')
  },
  {
    path: '/product/trial-loan',
    name: 'ProductTrialLoan',
    meta: {
      index: 57,
      title: '试算借款'
    },
    component: () => import('@/views/product/TrialLoan.vue')
  },
  {
    path: '/shoop/store-catalog',
    name: 'ProductStoreCatalog',
    meta: {
      index: 58,
      title: ''
    },
    component: () => import('@/views/shoop/StoreCatalog.vue')
  }
]
export default productRouter
